/**
 * Utility functions for data transformation
 */

import { formatDateTime } from "../../../functions/date-utils";
import { optinColors, optinLabels } from "../shared";

/**
 * Transform contact data for table display
 */
export const transformContactData = (data) => {
  if (!data) {
    return [];
  }

  return data.map((contact, index) => {
    const {
      id,
      optoutAt,
      firstName,
      whatsappName,
      lastName,
      shopifyCustomer,
      createdAt,
      updatedAt,
      userPhoneNumber,
      hasOptIn,
    } = contact;

    const consent = hasOptIn ? "optin" : optoutAt ? "optout" : "neverOptin";

    return {
      id,
      key: `contact-${index}`,
      name:
        (firstName ?? shopifyCustomer?.firstName ?? whatsappName ?? "") +
        " " +
        (lastName ?? shopifyCustomer?.lastName ?? ""),
      createdAt: createdAt ? formatDateTime(createdAt, "relative") : "-",
      updatedAt: updatedAt ? formatDateTime(updatedAt, "relative") : "-",
      createdAtOriginal: createdAt,
      updatedAtOriginal: updatedAt,
      phoneNumber: userPhoneNumber,
      hasOptin: hasOptIn,
      optinColor: optinColors[consent],
      optinLabel: optinLabels[consent],
    };
  });
};

/**
 * Get default fields for contact queries
 */
export const getDefaultFields = () => {
  return {
    id: true,
    firstName: true,
    lastName: true,
    userPhoneNumber: true,
    whatsappName: true,
    hasOptIn: true,
    optoutAt: true,
    createdAt: true,
    updatedAt: true,
    shopifyCustomer: {
      firstName: true,
      lastName: true,
    },
  };
};
